// src/JigsawBoard.js
import React, { useState, useRef } from 'react';
import html2canvas from 'html2canvas';

const JigsawBoard = ({ onAddToBook }) => {
  const [image, setImage] = useState(null); // التصويرة المرفوعة
  const [rows, setRows] = useState(4);
  const [cols, setCols] = useState(6);
  const [showImage, setShowImage] = useState(true); // واش تبين التصويرة ولا غير الخطوط
  const printRef = useRef();
  
  // متغير عشوائي باش يبدل شكل التقطيعات
  const [seed, setSeed] = useState(Date.now());

  // --- رفع الصورة ---
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => setImage(event.target.result);
      reader.readAsDataURL(file);
    }
  };

  const handleAddToBook = () => {
    if (printRef.current) html2canvas(printRef.current).then(canvas => onAddToBook('Jigsaw Puzzle', canvas.toDataURL()));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
      <h2 style={{ color: '#2c3e50' }}>Jigsaw Puzzle Generator 🧩</h2>

      {/* أدوات التحكم */}
      <div style={{ 
        background: 'white', padding: '20px', borderRadius: '15px', 
        marginBottom: '20px', width: '100%', maxWidth: '700px',
        display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center',
        boxShadow: '0 4px 10px rgba(0,0,0,0.05)'
      }}>
        
        {/* رفع صورة */}
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#636e72', display: 'block', marginBottom: '5px' }}>
            1. Upload Image
          </label>
          <input type="file" accept="image/*" onChange={handleImageUpload} style={{ fontSize: '12px' }} />
        </div>

        {/* التحكم فالعدد */}
        <div>
          <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#636e72' }}>Grid: {rows} x {cols}</label>
          <div style={{ display: 'flex', gap: '5px' }}>
            <input type="range" min="2" max="10" value={rows} onChange={(e) => setRows(parseInt(e.target.value))} />
            <input type="range" min="2" max="10" value={cols} onChange={(e) => setCols(parseInt(e.target.value))} />
          </div>
        </div>

        {/* إظهار/إخفاء الصورة */}
        <div>
          <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#636e72' }}>Style</label><br/>
          <button 
            onClick={() => setShowImage(!showImage)} 
            style={{ 
              background: showImage ? '#00b894' : '#dfe6e9', color: showImage ? 'white' : '#636e72',
              border: 'none', padding: '5px 10px', borderRadius: '5px', cursor: 'pointer', fontSize:'12px'
            }}
          >
            {showImage ? 'Show Image' : 'Outlines Only'}
          </button>
        </div>

        <button onClick={handleAddToBook} style={btnStyle('#e67e22')}>📖 Add to Book</button>
      </div>

      {/* منطقة البازل */}
      <div ref={printRef} style={{ 
        width: '600px', height: '450px', 
        border: '5px solid #333', position: 'relative', overflow: 'hidden',
        background: 'white'
      }}>
        
        {/* 1. الصورة الخلفية */}
        {image && showImage && (
          <img src={image} alt="Puzzle" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        )}
        
        {!image && showImage && (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#b2bec3', background: '#f5f6fa' }}>
            Upload an image to see it here
          </div>
        )}

        {/* 2. خطوط التقطيع (SVG Overlay) */}
        <svg 
          width="100%" height="100%" 
          viewBox={`0 0 ${cols * 100} ${rows * 100}`} 
          preserveAspectRatio="none"
          style={{ position: 'absolute', top: 0, left: 0 }}
        >
          {/* رسم الخطوط العمودية */}
          {Array.from({ length: cols - 1 }).map((_, c) => (
             Array.from({ length: rows }).map((_, r) => {
               const x = (c + 1) * 100;
               const yStart = r * 100;
               // عشوائية: لسان ليمين أو ليسار
               const isRight = (r + c + seed) % 2 === 0; 
               return (
                 <path 
                   key={`v-${c}-${r}`}
                   d={`M ${x} ${yStart} L ${x} ${yStart + 35} 
                      C ${x + (isRight?30:-30)} ${yStart + 35}, ${x + (isRight?30:-30)} ${yStart + 65}, ${x} ${yStart + 65}
                      L ${x} ${yStart + 100}`}
                   fill="none" 
                   stroke={showImage ? "rgba(255,255,255,0.8)" : "black"} 
                   strokeWidth="3"
                   // ظل خفيف باش يبان فوق التصويرة
                   filter={showImage ? "drop-shadow(0px 0px 2px rgba(0,0,0,0.5))" : ""}
                 />
               );
             })
          ))}

          {/* رسم الخطوط الأفقية */}
          {Array.from({ length: rows - 1 }).map((_, r) => (
             Array.from({ length: cols }).map((_, c) => {
               const y = (r + 1) * 100;
               const xStart = c * 100;
               const isDown = (r + c + seed) % 3 === 0;
               return (
                 <path 
                   key={`h-${r}-${c}`}
                   d={`M ${xStart} ${y} L ${xStart + 35} ${y} 
                      C ${xStart + 35} ${y + (isDown?30:-30)}, ${xStart + 65} ${y + (isDown?30:-30)}, ${xStart + 65} ${y}
                      L ${xStart + 100} ${y}`}
                   fill="none" 
                   stroke={showImage ? "rgba(255,255,255,0.8)" : "black"} 
                   strokeWidth="3"
                   filter={showImage ? "drop-shadow(0px 0px 2px rgba(0,0,0,0.5))" : ""}
                 />
               );
             })
          ))}
        </svg>

      </div>
    </div>
  );
};

const btnStyle = (bg) => ({ background: bg, color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' });

export default JigsawBoard;